module.exports = __webpack_public_path__ + "static/media/fluoro-enabled.de8637b4.svg";